"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * A beautiful and amazing RingRSESchedulingService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2024-06-27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.TenantId = exports.ServiceId = exports.Locale = exports.ChallengeType = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var ChallengeType;
(function (ChallengeType) {
    ChallengeType["Otpsms"] = "otp:sms";
})(ChallengeType = exports.ChallengeType || (exports.ChallengeType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Locale;
(function (Locale) {
    Locale["DeDe"] = "de-DE";
    Locale["EnUk"] = "en-UK";
    Locale["EsEs"] = "es-ES";
    Locale["FrFr"] = "fr-FR";
    Locale["ItIt"] = "it-IT";
})(Locale = exports.Locale || (exports.Locale = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ServiceId;
(function (ServiceId) {
    ServiceId["RsEdefault"] = "RSE:default";
    ServiceId["RingIntercomDe"] = "ring_intercom_DE";
    ServiceId["RingIntercomUk"] = "ring_intercom_UK";
    ServiceId["RingIntercomEs"] = "ring_intercom_ES";
    ServiceId["RingIntercomFr"] = "ring_intercom_FR";
    ServiceId["RingIntercomIt"] = "ring_intercom_IT";
})(ServiceId = exports.ServiceId || (exports.ServiceId = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TenantId;
(function (TenantId) {
    TenantId["Intercom"] = "intercom";
    TenantId["RingIntercom"] = "RingIntercom";
})(TenantId = exports.TenantId || (exports.TenantId = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentV1: async (appointmentId, options = {}) => {
            // verify required parameter 'appointmentId' is not null or undefined
            (0, common_1.assertParamExists)('cancelAppointmentV1', 'appointmentId', appointmentId);
            const localVarPath = `/api/v1/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentV2: async (appointmentId, options = {}) => {
            // verify required parameter 'appointmentId' is not null or undefined
            (0, common_1.assertParamExists)('cancelAppointmentV2', 'appointmentId', appointmentId);
            const localVarPath = `/api/v2/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CompleteAuthV1RequestContent} completeAuthV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAuthV1: async (completeAuthV1RequestContent, options = {}) => {
            // verify required parameter 'completeAuthV1RequestContent' is not null or undefined
            (0, common_1.assertParamExists)('completeAuthV1', 'completeAuthV1RequestContent', completeAuthV1RequestContent);
            const localVarPath = `/api/v1/auth/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completeAuthV1RequestContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateAppointmentV1RequestContent} createAppointmentV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentV1: async (createAppointmentV1RequestContent, options = {}) => {
            // verify required parameter 'createAppointmentV1RequestContent' is not null or undefined
            (0, common_1.assertParamExists)('createAppointmentV1', 'createAppointmentV1RequestContent', createAppointmentV1RequestContent);
            const localVarPath = `/api/v1/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAppointmentV1RequestContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateAppointmentV2RequestContent} createAppointmentV2RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentV2: async (createAppointmentV2RequestContent, options = {}) => {
            // verify required parameter 'createAppointmentV2RequestContent' is not null or undefined
            (0, common_1.assertParamExists)('createAppointmentV2', 'createAppointmentV2RequestContent', createAppointmentV2RequestContent);
            const localVarPath = `/api/v2/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAppointmentV2RequestContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentsV1: async (options = {}) => {
            const localVarPath = `/api/v1/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentsV2: async (options = {}) => {
            const localVarPath = `/api/v2/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentV1: async (appointmentId, options = {}) => {
            // verify required parameter 'appointmentId' is not null or undefined
            (0, common_1.assertParamExists)('getAppointmentV1', 'appointmentId', appointmentId);
            const localVarPath = `/api/v1/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentV2: async (appointmentId, options = {}) => {
            // verify required parameter 'appointmentId' is not null or undefined
            (0, common_1.assertParamExists)('getAppointmentV2', 'appointmentId', appointmentId);
            const localVarPath = `/api/v2/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TenantId} tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfigV1: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            (0, common_1.assertParamExists)('getTenantConfigV1', 'tenantId', tenantId);
            const localVarPath = `/api/v1/tenantConfig/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InitiateAuthV1RequestContent} initiateAuthV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAuthV1: async (initiateAuthV1RequestContent, options = {}) => {
            // verify required parameter 'initiateAuthV1RequestContent' is not null or undefined
            (0, common_1.assertParamExists)('initiateAuthV1', 'initiateAuthV1RequestContent', initiateAuthV1RequestContent);
            const localVarPath = `/api/v1/auth/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiateAuthV1RequestContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentV1RequestContent} updateAppointmentV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentV1: async (appointmentId, updateAppointmentV1RequestContent, options = {}) => {
            // verify required parameter 'appointmentId' is not null or undefined
            (0, common_1.assertParamExists)('updateAppointmentV1', 'appointmentId', appointmentId);
            // verify required parameter 'updateAppointmentV1RequestContent' is not null or undefined
            (0, common_1.assertParamExists)('updateAppointmentV1', 'updateAppointmentV1RequestContent', updateAppointmentV1RequestContent);
            const localVarPath = `/api/v1/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAppointmentV1RequestContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentV2RequestContent} updateAppointmentV2RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentV2: async (appointmentId, updateAppointmentV2RequestContent, options = {}) => {
            // verify required parameter 'appointmentId' is not null or undefined
            (0, common_1.assertParamExists)('updateAppointmentV2', 'appointmentId', appointmentId);
            // verify required parameter 'updateAppointmentV2RequestContent' is not null or undefined
            (0, common_1.assertParamExists)('updateAppointmentV2', 'updateAppointmentV2RequestContent', updateAppointmentV2RequestContent);
            const localVarPath = `/api/v2/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication smithy.api.httpApiKeyAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAppointmentV2RequestContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointmentV1(appointmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAppointmentV1(appointmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointmentV2(appointmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAppointmentV2(appointmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {CompleteAuthV1RequestContent} completeAuthV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeAuthV1(completeAuthV1RequestContent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeAuthV1(completeAuthV1RequestContent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateAppointmentV1RequestContent} createAppointmentV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointmentV1(createAppointmentV1RequestContent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointmentV1(createAppointmentV1RequestContent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateAppointmentV2RequestContent} createAppointmentV2RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointmentV2(createAppointmentV2RequestContent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointmentV2(createAppointmentV2RequestContent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointmentsV1(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointmentsV1(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointmentsV2(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointmentsV2(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentV1(appointmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentV1(appointmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentV2(appointmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentV2(appointmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {TenantId} tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantConfigV1(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantConfigV1(tenantId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {InitiateAuthV1RequestContent} initiateAuthV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateAuthV1(initiateAuthV1RequestContent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateAuthV1(initiateAuthV1RequestContent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentV1RequestContent} updateAppointmentV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentV1(appointmentId, updateAppointmentV1RequestContent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentV1(appointmentId, updateAppointmentV1RequestContent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentV2RequestContent} updateAppointmentV2RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentV2(appointmentId, updateAppointmentV2RequestContent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentV2(appointmentId, updateAppointmentV2RequestContent, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentV1(appointmentId, options) {
            return localVarFp.cancelAppointmentV1(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentV2(appointmentId, options) {
            return localVarFp.cancelAppointmentV2(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CompleteAuthV1RequestContent} completeAuthV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAuthV1(completeAuthV1RequestContent, options) {
            return localVarFp.completeAuthV1(completeAuthV1RequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateAppointmentV1RequestContent} createAppointmentV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentV1(createAppointmentV1RequestContent, options) {
            return localVarFp.createAppointmentV1(createAppointmentV1RequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateAppointmentV2RequestContent} createAppointmentV2RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentV2(createAppointmentV2RequestContent, options) {
            return localVarFp.createAppointmentV2(createAppointmentV2RequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentsV1(options) {
            return localVarFp.getAllAppointmentsV1(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentsV2(options) {
            return localVarFp.getAllAppointmentsV2(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentV1(appointmentId, options) {
            return localVarFp.getAppointmentV1(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentV2(appointmentId, options) {
            return localVarFp.getAppointmentV2(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TenantId} tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfigV1(tenantId, options) {
            return localVarFp.getTenantConfigV1(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InitiateAuthV1RequestContent} initiateAuthV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAuthV1(initiateAuthV1RequestContent, options) {
            return localVarFp.initiateAuthV1(initiateAuthV1RequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentV1RequestContent} updateAppointmentV1RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentV1(appointmentId, updateAppointmentV1RequestContent, options) {
            return localVarFp.updateAppointmentV1(appointmentId, updateAppointmentV1RequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentV2RequestContent} updateAppointmentV2RequestContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentV2(appointmentId, updateAppointmentV2RequestContent, options) {
            return localVarFp.updateAppointmentV2(appointmentId, updateAppointmentV2RequestContent, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelAppointmentV1(appointmentId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).cancelAppointmentV1(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelAppointmentV2(appointmentId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).cancelAppointmentV2(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompleteAuthV1RequestContent} completeAuthV1RequestContent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    completeAuthV1(completeAuthV1RequestContent, options) {
        return (0, exports.DefaultApiFp)(this.configuration).completeAuthV1(completeAuthV1RequestContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateAppointmentV1RequestContent} createAppointmentV1RequestContent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createAppointmentV1(createAppointmentV1RequestContent, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createAppointmentV1(createAppointmentV1RequestContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateAppointmentV2RequestContent} createAppointmentV2RequestContent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createAppointmentV2(createAppointmentV2RequestContent, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createAppointmentV2(createAppointmentV2RequestContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAllAppointmentsV1(options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAllAppointmentsV1(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAllAppointmentsV2(options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAllAppointmentsV2(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAppointmentV1(appointmentId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAppointmentV1(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAppointmentV2(appointmentId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAppointmentV2(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TenantId} tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getTenantConfigV1(tenantId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getTenantConfigV1(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InitiateAuthV1RequestContent} initiateAuthV1RequestContent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    initiateAuthV1(initiateAuthV1RequestContent, options) {
        return (0, exports.DefaultApiFp)(this.configuration).initiateAuthV1(initiateAuthV1RequestContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} appointmentId
     * @param {UpdateAppointmentV1RequestContent} updateAppointmentV1RequestContent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateAppointmentV1(appointmentId, updateAppointmentV1RequestContent, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateAppointmentV1(appointmentId, updateAppointmentV1RequestContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} appointmentId
     * @param {UpdateAppointmentV2RequestContent} updateAppointmentV2RequestContent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateAppointmentV2(appointmentId, updateAppointmentV2RequestContent, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateAppointmentV2(appointmentId, updateAppointmentV2RequestContent, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map